import React, { lazy } from 'react';
import { darken } from '@mui/material/styles';
import { Button as MuiButton } from '@mui/material';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

const SCustomButton = styled(
  ({ isActive, bgColor, textColor, theme, ...props }) => (
    <MuiButton {...props} />
  )
)`
  && {
    box-shadow: none;
    text-transform: none;
    font-size: 13px;
    min-height: 35px;
    line-height: 17px;
    font-weight: 500;
    padding: 4px 15px;
    border-radius: 20px;
    transition: all 0.3s;
    background-color: ${({ isActive, bgColor, theme }) =>
      isActive ? bgColor : theme.palette.colors.gray100};
    color: ${({ isActive, textColor, theme }) =>
      isActive ? textColor : theme.palette.colors.gray400};

    &:not(:last-child) {
      margin-right: 5px;
    }

    &:hover {
      background-color: ${({ bgColor }) => bgColor};
      color: ${({ textColor }) => textColor};
      box-shadow: none;
    }

    &:active {
      box-shadow: none;
      color: ${({ textColor }) => textColor};
      background-color: ${({ bgColor }) => bgColor && darken(bgColor, 0.1)};
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
    }
  }
`;

const CustomButton = ({ title, bgColor, color, isActive, onClick }) => {
  return (
    <SCustomButton
      variant="contained"
      disableRipple
      bgColor={bgColor}
      textColor={color}
      onClick={onClick}
      isActive={isActive}
    >
      {title}
    </SCustomButton>
  );
};

export default CustomButton;
